import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Navigate, useLocation, useParams } from 'react-router';
import user from 'store/user';

import styles from './styles.module.scss';

export const TokenLoginPage = () => {
  const location = useLocation();
  const params = useParams<{ token: string }>();
  const dispatch = useDispatch();

  const urlParams = new URLSearchParams(location.search);
  const redirectUrl = urlParams.get('redirectUrl') || '/';

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    dispatch(user.actions.setToken(atob(params.token)));
  }, []);

  return (
    <div className={styles.root}>
      Logging in...
      <Navigate to={redirectUrl} />
    </div>
  );
};
